<template>
    <footer>
      <div class="inner">
        <h1><router-link to="/"><img src="../assets/common/logo-footer.svg" alt="어썸멘토" /></router-link></h1>
        <div class="center">
          <ul>
            <li><a href="javascript:" @click="showPopup=true; popupContents=1;">개인정보처리방침</a></li>
            <li><a href="javascript:" @click="showPopup=true; popupContents=2;">이용약관</a></li>
            <li><a href="javascript:" @click="showPopup=true; popupContents=3;">환불정책</a></li>
            <li><router-link to="/membership">멤버쉽 구독하기</router-link></li>
          </ul>
          <div>
            <p>
              <span>(주)인사이트컨설팅</span>
              <span>대표자 : 이연하</span>
              <span>서울특별시 강남구 학동로 137-6(논현동) 인의빌딩 202</span>
            </p>
            <p>
              <span>사업자등록번호 : 211-88-97516</span>
              <span>대표메일 : <a href="mailto:awesomementor1@gmail.com">awesomementor1@gmail.com</a></span>
              <span>대표번호 : 02-6433-5734</span>
            </p>
          </div>
          <p>AwesomeMentor © 2022 Copyright</p>
        </div>
        <div class="right">
          <select class="en">
            <option value="">Family Site</option>
          </select>
        </div>
      </div>

      <ul id="quick">
        <li><router-link to=""><img src="../assets/common/btn-fixed-modify.svg" alt="modify"></router-link></li>
        <li><router-link to="/activity/add"><img src="../assets/common/btn-fixed-add.svg" alt="add"></router-link></li>
        <li><a href="javascript:" @click="scrollToTop()"><img src="../assets/common/btn-top.svg" alt="TOP"></a></li>
      </ul>

      <div class="popup">
        <div class="black"></div>
        <div clss="popup_inner">
          <div>
            <div class="popup_"></div>
          </div>
        </div>
      </div>

      <transition name="fade" mode="out-in">
          <div class="popup_wrap" v-if="showPopup===true">
            <div class="black" @click="showPopup=false"></div>
            <div class="inner w_640" v-if="popupContents==1">
              <div class="head">
                <p>개인정보처리방침</p>
                <a href="javascript:" class="btn_close" @click="showPopup=false"><img src="../assets/common/ico-24-close.svg" alt="닫기"></a>
              </div>
              <div class="body full">
                <p>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다.</p>
              </div>
            </div>

            <div class="inner w_640" v-if="popupContents==2">
              <div class="head">
                <p>이용약관</p>
                <a href="javascript:" class="btn_close" @click="showPopup=false"><img src="../assets/common/ico-24-close.svg" alt="닫기"></a>
              </div>
              <div class="body full">
                <p>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다.</p>
              </div>
            </div>

            <div class="inner w_640" v-if="popupContents==3">
              <div class="head">
                <p>환불정책</p>
                <a href="javascript:" class="btn_close" @click="showPopup=false"><img src="../assets/common/ico-24-close.svg" alt="닫기"></a>
              </div>
              <div class="body full">
                <p>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다.</p>
              </div>
            </div>
          </div>
      </transition>

    </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      CurrentRoute: this.$route.path,
      showPopup: false,
      popupContents: 1,
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({top:0,behavior:'smooth'});
    }
  },
  watch: {
    showPopup: function(){
      if (this.showPopup) {
        document.documentElement.style.overflow = 'hidden';
        return;
      } document.documentElement.style.overflow = 'auto';
    },
    $route(to, from) {
      if (to.path != from.path) {
        document.documentElement.style.overflow = 'auto';
      }
    }
  },
}
</script>

<style scoped>
</style>
